import { IconStar, IconStarHalf, IconStarOutline, css, isPropValid, styled } from '@migros/msrc-ui-kit';
import React, { useState } from 'react';
import { getI18n } from '../../translations/i18n';
import { mgbRatingStyles, migipediaRatingStyles } from './styles';
export let RatingSize = /*#__PURE__*/function (RatingSize) {
  RatingSize["tiny"] = "tiny";
  RatingSize["small"] = "small";
  RatingSize["normal"] = "normal";
  RatingSize["medium"] = "medium";
  RatingSize["large"] = "large";
  return RatingSize;
}({});
export const Rating = ({
  ratingRange,
  currentRating,
  editable,
  size = RatingSize.normal,
  onRatingChanged
}) => {
  const ratings = Array.from({
    length: ratingRange
  }, (_, k) => k + 1);
  const starRating = Math.round((currentRating || 0) * 2) / 2;
  const roundedRating = Math.round((currentRating || 0) * 10) / 10;
  return editable ? /*#__PURE__*/React.createElement(InputRating, {
    range: ratings,
    starRating: starRating,
    size: size,
    onRatingChanged: onRatingChanged
  }) : /*#__PURE__*/React.createElement(DisplayRating, {
    range: ratings,
    roundedRating: roundedRating,
    starRating: starRating,
    size: size
  });
};
const DisplayRating = ({
  range,
  roundedRating,
  starRating,
  size
}) => /*#__PURE__*/React.createElement(RatingContainer, {
  role: "img",
  size: size,
  "aria-label": getI18n().t('components.rating.stars', {
    count: roundedRating
  }, roundedRating)
}, range.map(i => {
  const active = i <= starRating || !Number.isInteger(starRating) && i === Math.ceil(starRating);
  const starIcon = i <= starRating ? 'Star' : i === Math.ceil(starRating) ? 'StarHalf' : 'StarOutline';
  return /*#__PURE__*/React.createElement(RatingSelectorSpan, {
    active: active,
    size: size,
    key: i,
    "aria-hidden": true,
    title: `${getI18n().t('components.rating.tooltip-label')}: ${roundedRating}`
  }, getStarIcon(starIcon));
}));
const InputRating = ({
  range,
  starRating,
  size,
  onRatingChanged
}) => {
  const [currentHover, setCurrentHover] = useState(0);
  return /*#__PURE__*/React.createElement(RatingContainer, {
    size: size
  }, range.map(i => {
    const active = !currentHover && (i <= starRating || !Number.isInteger(starRating) && i === Math.ceil(starRating));
    const starIcon = i <= currentHover || i <= starRating ? 'Star' : i === Math.ceil(starRating) ? 'StarHalf' : 'StarOutline';
    return /*#__PURE__*/React.createElement(RatingSelectorButton, {
      size: size,
      key: i,
      editable: true,
      active: active || i <= currentHover,
      "aria-pressed": i === starRating,
      onMouseOver: () => {
        setCurrentHover(i);
      },
      onMouseOut: () => {
        setCurrentHover(0);
      },
      onClick: () => onRatingChanged && onRatingChanged(i),
      title: getI18n().t('components.rating.stars', {
        count: i
      }, i)
    }, getStarIcon(starIcon));
  }));
};
const getStarIcon = type => {
  switch (type) {
    case 'Star':
      return /*#__PURE__*/React.createElement(StyledStarIcon, {
        className: type
      });
    case 'StarHalf':
      return /*#__PURE__*/React.createElement(StyledStarHalfIcon, {
        className: type
      });
    case 'StarOutline':
      return /*#__PURE__*/React.createElement(StyledStarOutlineIcon, {
        className: type
      });
    default:
      return /*#__PURE__*/React.createElement(StyledStarIcon, {
        className: type
      });
  }
};
const RatingContainer = styled.div.withConfig({
  shouldForwardProp: isPropValid
})`
  height: ${({
  size
}) => mapRatingSizeToFontSize[size]};
  white-space: nowrap;
`;
const StyledStarIcon = styled(IconStar)`
  pointer-events: none;
`;
const StyledStarOutlineIcon = styled(IconStarOutline)`
  pointer-events: none;
`;
const StyledStarHalfIcon = styled(IconStarHalf)`
  pointer-events: none;
`;
const ratingStyles = {
  mgb: mgbRatingStyles,
  migipedia: migipediaRatingStyles,
  migipediaDark: migipediaRatingStyles
};
const ratingSelector = css`
  text-decoration: none;
  padding-right: ${({
  size,
  theme
}) => size === RatingSize.small || size === RatingSize.tiny ? 0 : theme.spacings.tiny};
  &:last-child {
    margin-right: 0;
  }
  font-size: ${({
  size
}) => mapRatingSizeToFontSize[size]};
  line-height: 0;

  ${({
  theme: {
    themeId
  }
}) => ratingStyles[themeId] || ratingStyles.mgb}
`;
const RatingSelectorSpan = styled.span.withConfig({
  shouldForwardProp: isPropValid
})`
  ${ratingSelector}
`;
const RatingSelectorButton = styled.button.withConfig({
  shouldForwardProp: isPropValid
})`
  display: inline-block;
  cursor: pointer;
  background-color: transparent;
  border: none;
  appearance: none;
  outline: none;
  padding: 0;
  margin: 0;
  ${ratingSelector}
`;
const mapRatingSizeToFontSize = {
  [RatingSize.tiny]: '10px',
  [RatingSize.small]: '13px',
  [RatingSize.normal]: '16px',
  [RatingSize.medium]: '25px',
  [RatingSize.large]: '35px'
};